import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Queue } from "../_types/queue";

@Injectable({
    providedIn: 'root',
})

export class QueuesService extends Service<Queue> {
  public override type = 'queues';
  public override url = 'Voip/queues';

}
